import { useEffect, useState } from "react";

function Services() {
  const [pricingVisible, setPricingVisible] = useState(false);
  const [ctaVisible, setCtaVisible] = useState(false);

  useEffect(() => {
    // Animate step cards with stagger
    const cards = document.querySelectorAll(".step-card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, idx) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("show");
              observer.unobserve(entry.target);
            }, idx * 150);
          }
        });
      },
      { threshold: 0.2 }
    );
    cards.forEach((card) => observer.observe(card));

    // Observe pricing box
    const pricing = document.querySelector(".pricing-box");
    const pricingObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setPricingVisible(true);
            pricingObserver.unobserve(entry.target);

            // Show CTA after pricing is shown
            setTimeout(() => {
              setCtaVisible(true);
            }, 600); // adjust delay if needed
          }
        });
      },
      { threshold: 0.3 }
    );
    if (pricing) pricingObserver.observe(pricing);

    return () => {
      pricingObserver.disconnect();
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <section className="services-section bg-default text-center" id="services">
        <div className="container px-4 px-lg-5">

          {/* === HERO === */}
          <h1 className="text-white mb-3 big-title">Our Services</h1>
          <p className="text-white-80 lead hero-subtext mb-5">
            Trusted ACCA accountants, making your Capital Gains Tax (CGT) file & pay process simple, fast, and stress-free with our 5 step system.
          </p>

          {/* === STEP CARDS === */}
          <div className="row gx-4 gy-4 justify-content-center text-start">
            {[...Array(5)].map((_, i) => (
              <div className="col-md-6 col-lg-4" key={i}>
                <div className="step-card">
                  <div className="step-icon">{i + 1}</div>
                  <h5>
                    {[
                      "Smart Online Forms",
                      "Reliefs & Savings Check",
                      "Accurate Calculation",
                      "HMRC Registration Help",
                      "File & Pay Submission",
                    ][i]}
                  </h5>
                  <p>
                    {[
                      "Fill out our tailored forms to provide the most relevant details for your submission, quickly and easily.",
                      "We will identify any reliefs or exemptions available to reduce your tax liability.",
                      "Our accountants calculate your tax and deliver a clear summary via email and a phone call if needed.",
                      "We guide you step-by-step through HMRC's CGT registration process to appoint us as your agent.",
                      "We finalise your CGT calculations with you and complete your CGT submission to HMRC. You pay HMRC directly and we show you how to make your payment - we never handle your money.",
                    ][i]}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-white-80 mt-4">
            All steps are completed well within your 60‑day timeframe, with urgent cases handled immediately and confidentially.
          </p>

          {/* === PRICING BOX === */}
          <h2 className="text-white mt-5 mb-3 section-title">Pricing</h2>
          <div className={`pricing-box text-white-80 mx-auto ${pricingVisible ? "show" : ""}`}>
            <p>Our pricing is tailored to your case and provided once you complete our quick questionnaire. Our fees are fixed with no hidden fees.</p>
            <p><strong>Please note:</strong> Your data stays secure — we never share your information and your tax file file is handled by qualified professionals only.</p>
            <p>From simple to complex cases, you’ll only pay when you approve your final calculation for HMRC submission.</p>
          </div>

          {/* === CTA === */}
          <div className={`cta-box mt-5 ${ctaVisible ? "show" : ""}`}>
            <h4 className="text-white mb-3"><b>Start your journey with us today.</b></h4>
            <p className="cta-text mb-4">Complete our quick form now and let our expert accountants handle the rest—accurate, compliant, and stress-free.</p>
            <a
              href="https://chatcgt.typeform.com/to/rUw4Egui"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary px-4 py-3"
            >
              Check My CGT Now
            </a>
          </div>

        </div>
      </section>
    </>
  );
}

export default Services;
